(() => {
  'use strict';
  if(customElements.get('nikuya-parallax'))return;
  const directions={right:0,top:90,left:180,bottom:270};
  const multipliers={0:[1,0],90:[0,-1],180:[-1,0],270:[0,1]};
  class NikuyaParallax extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;this.image=this.querySelector('[data-parallax-image]');if(!this.image)return;
      this.controller=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      const schedule=()=>{if(this.frame||this.motion.matches)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      this.motion.addEventListener('change',()=>{if(this.motion.matches){cancelAnimationFrame(this.frame);this.frame=0;this.image.removeAttribute('style');}else schedule();},{signal:this.controller.signal});
      addEventListener('scroll',schedule,{passive:true,signal:this.controller.signal});addEventListener('resize',schedule,{passive:true,signal:this.controller.signal});schedule();
    }
    update(){
      if(!this.isConnected||this.motion.matches)return;
      const {width,height,top}=this.image.getBoundingClientRect();let angle=directions[this.dataset.direction]??Number.parseFloat(this.dataset.direction);
      if(!Number.isFinite(angle))angle=270;angle=((angle%360)+360)%360;
      const amount=Number.parseFloat(this.dataset.movement);const movement=Math.ceil((this.dataset.direction==='top'?height:width)*(Number.isFinite(amount)?amount:15)/100);
      const vector=multipliers[angle]||[Math.cos(angle*Math.PI/180),-Math.sin(angle*Math.PI/180)];
      this.image.style[angle>90&&angle<270?'left':'right']='0';this.image.style[angle<180?'top':'bottom']='0';
      if(vector[0])this.image.style.width=`calc(100% + ${movement*Math.abs(vector[0])}px)`;
      if(vector[1])this.image.style.height=`calc(100% + ${movement*Math.abs(vector[1])}px)`;
      const progress=(innerHeight-top)/(innerHeight+height);
      if(progress>-.1&&progress<1.1){const position=Math.min(Math.max(progress,0),1)*movement;this.image.style.transform=`translate3d(${position*vector[0]}px,${position*vector[1]}px,0)`;}
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;cancelAnimationFrame(this.frame);this.frame=0;}
  }
  customElements.define('nikuya-parallax',NikuyaParallax);
})();
